import _sliceInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/slice";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";
import React from 'react';
import { createComponent, PropTypes } from "../../../wayin-react";
import cx from 'classnames';
import { whitelistStyles } from "../../core/hoc";
import IsInvertedProvider from "../is-inverted-provider"; //  our custom components

import Label from "../../core/label";
import PopupMenu from "../popup-menu";
import { colors, sizes, positions, display } from "../../../enums";
var Pill = createComponent({
  displayName: 'Pill',
  propTypes: {
    items: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.shape({
      icon: PropTypes.string,
      text: PropTypes.string,
      byline: PropTypes.string,
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
    })), PropTypes.arrayOf(PropTypes.string)]).isRequired,
    position: PropTypes.oneOf(positions.ALL),
    size: PropTypes.oneOf(sizes.ALL),
    onItemClick: PropTypes.func
  },
  defaultProps: {
    position: positions.BOTTOM,
    size: sizes.M,
    onItemClick: null
  },
  contextTypes: {
    isInverted: PropTypes.bool
  },
  handlers: {
    handleItemClick: function handleItemClick(p) {
      return function (e, _ref) {
        var value = _ref.value;
        p.onItemClick(e, {
          value: value
        });
      };
    }
  },
  render: function render(p) {
    var _cx2, _cx3, _context;

    var _cx = cx((_cx2 = {
      ck: true,
      pill: true,
      'pill--inverted': p.isInverted
    }, _cx2["pill--" + p.position] = p.position, _cx2["pill--" + p.size] = p.size, _cx2));

    var _cxPill = cx((_cx3 = {
      'pill-label': true
    }, _cx3["pill-label--" + p.size] = p.size, _cx3));

    var _firstItem = p.items[0];

    var _rest = _sliceInstanceProperty(_context = p.items).call(_context, 1);

    return /*#__PURE__*/React.createElement(IsInvertedProvider, {
      isInverted: p.isInverted
    }, /*#__PURE__*/React.createElement("div", {
      className: _cx,
      style: p.style
    }, typeof _firstItem === 'string' ? /*#__PURE__*/React.createElement(Label, {
      onClick: p.handleItemClick,
      text: _firstItem,
      color: colors.ACCENT,
      size: p.size,
      value: 0
    }) : /*#__PURE__*/React.createElement(Label, {
      text: _firstItem.text,
      icon: _firstItem.icon,
      color: colors.ACCENT,
      size: p.size,
      onClick: p.handleItemClick,
      value: _firstItem.value || 0
    }), _rest.length > 0 ? /*#__PURE__*/React.createElement(PopupMenu, {
      position: p.position,
      onItemClick: p.handleItemClick,
      trigger: /*#__PURE__*/React.createElement("div", {
        className: _cxPill
      }, /*#__PURE__*/React.createElement(Label, {
        color: colors.ACCENT,
        display: display.SOLID,
        text: "+" + _rest.length,
        size: p.size
      }))
    }, _mapInstanceProperty(_rest).call(_rest, function (item, idx) {
      return typeof item === 'string' ? /*#__PURE__*/React.createElement(PopupMenu.Item, {
        key: idx,
        text: item
      }) : /*#__PURE__*/React.createElement(PopupMenu.Item, {
        key: idx,
        icon: item.icon,
        text: item.text,
        byline: item.byline,
        value: item.value || idx,
        size: p.size
      });
    }, this)) : null));
  }
});
export default whitelistStyles()(Pill);
//# sourceMappingURL=index.js.map